"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _SubdomainsActions = require("../actions/SubdomainsActions");

var defaultState = (0, _immutable.List)();

var _default = (0, _fluxActions.handleActions)((0, _defineProperty2.default)({}, _SubdomainsActions.FetchSubdomainsActionTypes.SUCCESS, function (state, _ref) {
  var data = _ref.payload.data;
  return (0, _immutable.fromJS)(data);
}), defaultState);

exports.default = _default;
module.exports = exports.default;